import { render, staticRenderFns } from "./BaseTextAreaInput.vue?vue&type=template&id=2d88662d&scoped=true&"
import script from "./BaseTextAreaInput.vue?vue&type=script&lang=js&"
export * from "./BaseTextAreaInput.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/base.css?vue&type=style&index=0&id=2d88662d&prod&scoped=true&lang=css&"
import style1 from "./BaseTextAreaInput.vue?vue&type=style&index=1&id=2d88662d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d88662d",
  null
  
)

export default component.exports